import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import Pagination from '../../../components/Pagination';
import { Context } from '../../../config/store';
import { toast } from 'react-toastify';
import LenderUgroService from '../../../services/lender';
import message from '../../../constant/message';
import Modal from '../../../components/Modal';

const ApiCollectionLogDetails = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const { state, dispatch } = React.useContext(Context);
    const [apiData, setApiData] = React.useState([])
    const leadId = location?.pathname?.split('/')[2]
    const lenderId = location?.pathname?.split('/')[3]
    const leadType = location?.pathname?.split('/')[4]
    const [page, setCurrentPage] = React.useState(1);
    const [pagination, setPagination] = React.useState({});
    const [isLoading, setIsLoading] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [modalState, setModalState] = useState(false);
    const [collections, setCollections] = useState([]);

    React.useEffect(() => {
        getApiData();
    }, [])

    const toggleModal = () => {
        setModalState(!modalState)
    }

    const copyText = (textObj) => {
        navigator.clipboard.writeText(JSON.stringify(textObj));
        toast.info('Text Copied!');
    }

    const lenders = {1: 'SBI', 15: 'UCO', 16: 'KVB', 20: 'KARNATAKA'};

    const getApiData = async () => {
        setIsLoading(true)
        let res = await LenderUgroService.getApiCollectionLogResponses({
            type: state.userType,
            cl_lead_id: leadId,
            cl_lender_id: lenderId,
            lead_type: leadType,
            page: page,
            dataExport: 0
        });
        res?.data?.data?.log_data?.map((item) => {
            item.isSelectedreq = false
            item.isSelectedres = false
            // if ((item?.action_type === "response") && (item?.api_status === 0)) {
            //     setIsLogFailed(true)
            // }
        })
        setApiData(res?.data?.data?.log_data)
        setCurrentPage(page);
        setPagination(res?.data?.data?.log_list?.pagination);
        setIsLoading(false)
    }

    const handleShowHide = (itemId, type) => {
        let data = apiData;
        data?.map((item) => {
            if (item?.id+type === itemId && type === 'req') {
                item.isSelectedreq = !(item.isSelectedreq)
                item.isSelectedres = false;
            } else if (item?.id+type === itemId && type === 'res') {
                item.isSelectedres = !(item.isSelectedres)
                item.isSelectedreq = false;
            } else {
                item.isSelectedreq = false;
                item.isSelectedres = false;
            }
        })
        setApiData(prevState => [...data])
    }

    const getLenderCollections = async () => {
        setLoading(true)
        try {
          let res = await LenderUgroService.getLenderCollections({
            type: state.userType,
            cl_lead_id: leadId,
            cl_lender_id: lenderId
          });
          if (res?.data?.status?.code === 1) {
            setLoading(false)
            setCollections(res?.data?.data || []);
            toggleModal();
          }
        } catch (error) {
          toast.error(error?.response?.data?.messages?.error?.others[0] || message?.ERROR)
          setLoading(false)
        }
      }

    // Uncomment if it's needed in future
    //   const changeApiLogStatus = async (id) => {
    //     setLoading(true)
    //     try {
    //       let res = await LenderUgroService.changeApiCollectionLogStatus({
    //         type: state.userType,
    //         id: id,
    //         cl_lender_id: lenderId
    //       });
    //       if (res?.data?.status?.code === 1) {
    //         setLoading(false)
    //         toggleModal()
    //         toast.success(res?.data?.messages?.success?.others[0])
    //         getApiData()
    //       } else {
    //         setLoading(false)
    //         toast.error(res?.data?.messages?.error?.others[0])
    //       }
    //     } catch (error) {
    //       toast.error(error?.response?.data?.messages?.error?.others[0] || error?.response?.data?.messages?.success?.others[0])
    //       setLoading(false)
    //     }
    //   }
    const checkHasPermission = (checkPermission) => {
        if (state.is_super_admin === 1) return true;
        const permission = state.permission.find(
            (permission) => permission === checkPermission
        );

        if (permission) return true;
        else return false;
    };

    return (
        <>
            {isLoading ?
                <div className='logsLoaderContainer'>
                    <div className="loader"></div>
                </div>
                :
                <div className='mt-1'>
                    <div className=''>
                        <div className='apilogsHeader'>
                            <button
                                onClick={() => { navigate(`/portfolio/collections`) }}
                                type='button'
                                className='btn btn-outline-custom'
                            >
                                <i class="fa fa-chevron-left mr-1"></i>
                                Back
                            </button>
                            {lenderId == 20 && apiData?.length && <button
                                onClick={getLenderCollections}
                                disabled={loading}
                                type='button'
                                className='btn btn-outline-custom'
                            >
                                {loading ? <div className="loader"></div> : 'Get Collection'}
                            </button>}
                        </div>
                        <div className='api_log_header'>
                            {`${(lenders[lenderId] || '')} COLLECTION LOGS`}
                        </div>
                        <div className='api_logs_container'>
                            {apiData?.length > 0 ?
                                apiData?.map((item, index) => {
                                    return (
                                        <>
                                            <div className="chart-card leadRequest mb-2" key={item?.id+'req'}>
                                                <h2 className='h5' onClick={() => { handleShowHide(item?.id+'req', 'req') }}>
                                                    <div style={{ display: "flex", justifyContent: 'space-between', alignItems: "center" }}>
                                                        <div>
                                                            {`${item?.api_enpoint_name} (request)`}
                                                        </div>
                                                        <div>
                                                            <span>Created At :  {item?.created_at}</span>
                                                        </div>
                                                    </div>
                                                </h2>
                                                {item?.isSelectedreq &&
                                                    <p>{JSON.stringify(item?.req_json)}</p>
                                                }
                                            </div>
                                            <div className="chart-card leadRequest mb-2" key={item?.id+'res'}>
                                                <h2 className={!item.api_status && 'text-danger'} onClick={() => { handleShowHide(item?.id+'res', 'res') }}>
                                                    <div style={{ display: "flex", justifyContent: 'space-between', alignItems: "center" }}>
                                                        <div>
                                                            {`${item?.api_enpoint_name} (response)`}
                                                        </div>
                                                        <div>
                                                            <span>Created At :  {item?.created_at}</span>
                                                        </div>
                                                    </div>
                                                </h2>
                                                {item?.isSelectedres &&
                                                    <p>{JSON.stringify(item?.res_json)}</p>
                                                }
                                            </div>
                                        </>
                                    )
                                })
                                :
                                <p className='text-center text-danger m-0'>No Records Found</p>
                            }
                        </div>
                    </div>
                    <div className="my-2">
                        {pagination?.total_pages ? (
                            <Pagination
                                // disabled={loading}
                                // setPage={setCurrentPage}
                                total_pages={5}
                                total={pagination.total}
                                showTotal={true}
                            />
                        ) : (
                            ""
                        )}
                    </div>
                </div>
            }
            <Modal state={modalState} closeModal={toggleModal} style={{ width: "475px", height: (collections.length ? "500px" : '120px'), }} removeBorderSpace={true} closeOnOverlayClick={false}>
                <div className="modal-header-container">
                <div className="modal-title">Collection</div>
                <div className="closeModalView" onClick={toggleModal}>
                    <span className="closeModalIcon">x</span>
                </div>
                </div>
                <div className='p-4'>
                    {collections.length && <i class="fa fa-clipboard" title="Click to Copy" style={{'float': 'right', 'margin-left': '5px', 'font-size': '15px', 'color': '#4A4E88', 'cursor': 'pointer'}} aria-hidden="true" onClick={()=>copyText(collections)}></i>}
                    <div style={{ overflowY: "scroll", overflowX: 'clip', padding: "2%" }}>
                    <div class='form-group'>
                        <div class='row'>
                        <div class='col-12' style={{'max-height': '375px'}}>
                            {collections.length ? <pre style={{'fontSize': '12px', 'overflow': 'hidden'}}>{JSON.stringify(collections, null, 2) }</pre> : <span style={{'marginLeft': '39%'}}>No collection found</span>}
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default ApiCollectionLogDetails